import { ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit'
import { sendMfaOtpToEmployee, sendMfaOtpToHotel } from './mfa-thunks'

type MfaOtpSendStatus = 'idle' | 'sending' | 'succeeded' | 'failed'

type MfaOtpSendState = {
  status: MfaOtpSendStatus
  error: string | undefined
}

// 送信先ごとに分ける。施設代表メールの送信状態とエラーはポップアップだけが扱い、入力画面のものと混ぜないため
type MfaState = {
  employeeSend: MfaOtpSendState
  hotelSend: MfaOtpSendState
}

const initialSendState: MfaOtpSendState = { status: 'idle', error: undefined }

const initialState: MfaState = {
  employeeSend: initialSendState,
  hotelSend: initialSendState,
}

const addSendCases = (
  builder: ActionReducerMapBuilder<MfaState>,
  thunk: typeof sendMfaOtpToEmployee,
  key: keyof MfaState,
) => {
  builder
    .addCase(thunk.pending, state => {
      state[key] = { status: 'sending', error: undefined }
    })
    .addCase(thunk.fulfilled, state => {
      state[key] = { status: 'succeeded', error: undefined }
    })
    .addCase(thunk.rejected, (state, action) => {
      state[key] = { status: 'failed', error: action.payload }
    })
}

export const mfaSlice = createSlice({
  name: 'mfa',
  initialState,
  reducers: {
    // store は画面をまたいで残るため、別のログインで出たエラーや状態を持ち越さないよう画面を離れるときに戻す
    resetMfaOtpSend: () => initialState,
    clearEmployeeSendError: state => {
      state.employeeSend.error = undefined
    },
    clearHotelSendError: state => {
      state.hotelSend.error = undefined
    },
  },
  extraReducers(builder) {
    addSendCases(builder, sendMfaOtpToEmployee, 'employeeSend')
    addSendCases(builder, sendMfaOtpToHotel, 'hotelSend')
  },
})

export const { resetMfaOtpSend, clearEmployeeSendError, clearHotelSendError } = mfaSlice.actions
export const mfaReducer = mfaSlice.reducer
